import { classnames } from 'Utils/classnames/classnames.utils';

export const themes = (isExclusiveCollection) => {
  return {
    default: {
      thRoot:
        'flex flex-col w-full justify-center sm:flex-row sm:flex-wrap gap-x-10 py-10 sm:py-20 px-5 sm:px-20 sm:items-baseline text-14 sm:text-16',
      thTitle: classnames('font-brand text-18 font-bold leading-1', {
        'text-black': !isExclusiveCollection,
        'text-ultramarine': isExclusiveCollection,
      }),
      thLabel: 'leading-1 font-bold font-sans text-sienna',
    },
    column: {
      thRoot: 'flex flex-col items-center py-10 px-5 text-12 w-full',
      thTitle: classnames('font-brand text-18 font-bold leading-1', {
        'text-black': !isExclusiveCollection,
        'text-ultramarine': isExclusiveCollection,
      }),
      thLabel: 'leading-1 font-bold font-sans text-sienna',
    },
  };
};
